import React, { useContext } from "react"
import { Route, Redirect, useLocation } from "react-router-dom";
import { InsurancePurchaseContextStore } from "../../../context/InsuracePurchaseContext";
import { SessionService } from "../../../services/SessionService";
import { SessionContextStore } from "../../../context/SessionContext";


export const FlowProtectedRoute = ({children, ...rest}) => {
    const insuranceContext = useContext(InsurancePurchaseContextStore)

    return (
        <Route
          {...rest}
          render={({ location }) =>{
            if (insuranceContext.selectedOption.offerId) {
              if (!SessionService.isLoggedIn() && location.pathname == '/insurance/summary') {
                return <Redirect
                to={{
                  pathname: "/insurance",
                  state: { from: location }
                }}
              />
              }
              return children 
            }
            else {
              return <Redirect
                to={{
                  pathname: "/insurance",
                  state: { from: location }
                }}
              />
            }
          }
 
          }
        />
      );
}